module.exports = __webpack_public_path__ + "static/media/explore-1c.615ef48d.jpeg";